import React, { useEffect, useState } from "react";
import { apiClient } from "../api_client";

export default function StartRacePage({ eventId }) {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formattedTime = time.toLocaleTimeString();

  const startRace = async (e) => {
    try {
      const startTime = new Date().toISOString();

      await apiClient.events.startNow(eventId, startTime);
      alert("Event Started");

      window.location.href = `/events/${eventId}`;
    } catch (e) {
      showToast(e, "error");
    }
  };

  return (
    <div className="container text-center">

      <h1 className="mb-4">
        <i className="fa-solid fa-timer me-2"></i>
        Start the Race
      </h1>

      {/* Clock */}
      <div className="my-5">
        <div style={{ fontSize: "4rem", fontWeight: "bold" }}>
          {formattedTime}
        </div>
      </div>

      {/* Start button */}
      <button
        onClick={startRace}
        className="btn btn-lg btn-success d-flex align-items-center justify-content-center px-5 py-3 shadow-lg mx-auto"
      >
        <i className="fa-solid fa-play me-2"></i>
        Start Race Now
      </button>

    </div>
  );
}